import axios from 'axios'
import { incrementLoaderStatus, decrementtLoaderStatus } from '../store/generalLoader'
import createStore from '../store/createStore'
import { getLocation } from "../routes/Home/helpers/location";

const serverUrl = process.env.SERVER_URL

/**
 * Http client instance
 * @param auth
 * @returns {AxiosInstance}
 * @constructor
 */
export function HttpClient(auth = false) {
  let token = storageTokenGet()
  let config = {
    baseURL: serverUrl,
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
      'Pragma': 'no-cache',
      'Cache-Control': 'no-cache, no-store, max-age=0, must-revalidate',
      'Expires': '-1',
      'X-Requested-With': 'xooker_deal_marketplace/v1.0'
    },
    responseType: 'json',
    transformRequest: [
      function (data) {
        return JSON.stringify(data)
      }
    ]
  }

  if (token !== null && auth) {
    config.headers['Authorization'] = 'JWT ' + token
  }
  const location = getLocation();
  if (location && location !== "Blocked") {
    config.headers['X-User-Location'] = JSON.stringify(location);
  }

  let request = axios.create(config)

  const store = createStore
  request.interceptors.request.use(function (config) {
    store.dispatch(incrementLoaderStatus())
    return config
  }, function (error) {
    // store.dispatch(incrementLoaderStatus())
    return Promise.reject(error)
  })

// Add a response interceptor
  request.interceptors.response.use(function (response) {
    store.dispatch(decrementtLoaderStatus())
    return response
  }, function (error) {
    store.dispatch(decrementtLoaderStatus())
    return Promise.reject(error)
  })

  return request
}

/**
 * Save token to storage (check expired)
 *
 * @param value
 * @param long
 * @returns {{value: *, timestamp: number}}
 */
export function storageTokenSave(value, long = false) {
  let now = new Date().getTime();
  let timestamp = now + 86400000; // 1 days
  if (long) {
    timestamp = now + 2592000000; // 30 days
  }
  if (value === false) {
    timestamp = 0;
  }
  let object = { value: value, timestamp: timestamp };
  localStorage.setItem('token', JSON.stringify(object));
  return object;
}

/**
 * Get token from storage (check expired)
 */
export function storageTokenGet() {
  let tokenStr = localStorage.getItem('token') || '{"value": false, "timestamp": 0}',
    object = JSON.parse(tokenStr),
    now = new Date().getTime();
  if (object.timestamp <= now) {
    object = storageTokenSave(false);
  }
  return object.value;
}



// WEBPACK FOOTER //
// ./src/core/request.js